import React from 'react';
import { io, Socket } from "socket.io-client";
import TagManager from 'react-gtm-module';
import './App.scss';
import { SplashScreen } from './views/SplashScreen/SplashScreen';
import Localization from './views/Localization/Localization';
import Layout from './views/Layout';
import Presentation from './views/Presentation/Presentation';
import Player from './views/Player/Player';
import DeviceOffline from './views/DeviceOffline/DeviceOffline';
import { PilotService } from "./service/pilot.service";
import PresentationInProgress from './views/PresentationInProgress/PresentationInProgress';

enum SWITCH { A, B }
enum SWTICH_STATE { OFF, ON }

export interface IAppState {
  audio: boolean,
  welcome: boolean,
  localization: boolean,
  presentationInProgress: boolean
  play: boolean
  pilot: boolean
  online: boolean,
  playlist: number[],
  initialTime: number,
  join: boolean,
  song: {
    time: number,
    total: number,
    index: number
  }
}

class App extends React.Component<any, IAppState> {
  audioFiles = [
    "/music/1.mp3",
    "/music/2.mp3",
    "/music/3.mpeg"
  ];
  socket: Socket = io();
  audio = React.createRef<HTMLAudioElement>();
  pilot: PilotService = new PilotService(this.socket);
  constructor(props: any) {
    super(props);

    this.state = { ...this.getInitialState(), audio: false };

    // Inicjalizacja GTM
    const tagManagerArgs = {
      gtmId: 'GTM-MV3B9W7R'
    };
    TagManager.initialize(tagManagerArgs);
  }

  componentWillUnmount() {

  }

  getInitialState() {
    return {
      welcome: false,
      localization: false,
      presentationInProgress: false,
      play: false,
      pilot: false,
      online: false,
      join: false,
      playlist: [0, 0, 0],
      initialTime: 0,
      song: {
        time: 0,
        total: 0,
        index: -1
      }
    }
  }

  onLocalizationOk = () => {
    this.socket.emit("okLocation");
    this.setState({ localization: true });

    // Event GTM - lokalizacja zatwierdzona
    TagManager.dataLayer({
      dataLayer: {
        event: 'localization_approved',
        event_category: 'user_interaction',
        event_label: 'location_confirmed'
      }
    });
  }
  componentDidMount() {
    // Event GTM - uruchomienie aplikacji
    TagManager.dataLayer({
      dataLayer: {
        event: 'app_start',
        event_category: 'app_lifecycle',
        event_label: 'application_mounted'
      }
    });

    for (var i in this.audioFiles) {
      this.preloadAudio(this.audioFiles[i]);
    }

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === 'hidden') {
        this.socket.disconnect();
      }
    });    this.socket.on("connect", () => {
      this.socket.emit("client");
      
      // Event GTM - połączenie z serwerem
      TagManager.dataLayer({
        dataLayer: {
          event: 'socket_connected',
          event_category: 'connection',
          event_label: 'server_connection_established'
        }
      });
    });    this.socket.on("disconnect", () => {
      this.setState(this.getInitialState());
      
      // Event GTM - rozłączenie z serwerem
      TagManager.dataLayer({
        dataLayer: {
          event: 'socket_disconnected',
          event_category: 'connection',
          event_label: 'server_connection_lost'
        }
      });
    });

    this.socket.on("relay", (state: number) => {
      this.setState({ online: state == 1 });
      if (state == 0) {
        this.socket.disconnect();
      }
    });

    this.socket.on("playlist", (playlist: any) => {
      this.setState({ playlist: playlist });
    });

    this.socket.on("pilot", () => {
      this.setState({ pilot: true });
    });    this.socket.on("play", () => {
      this.setState({ play: true });
      
      // Event GTM - rozpoczęcie odtwarzania
      TagManager.dataLayer({
        dataLayer: {
          event: 'playback_started',
          event_category: 'media',
          event_label: 'music_playback_initiated'
        }
      });
    });    this.socket.on("time", (data: { time: number, total: number, index: number }) => {
      const previousIndex = this.state.song.index;
      this.setState({ song: data });

      // Event GTM - zmiana utworu
      if (previousIndex !== data.index && data.index >= 0) {
        const songNames = ['V Symfonia - Beethoven', 'Rydwany Ognia - Vangelis', "Don't stop me now - Queen"];
        
        TagManager.dataLayer({
          dataLayer: {
            event: 'song_changed',
            event_category: 'media',
            event_label: songNames[data.index] || `Song ${data.index}`,
            song_index: data.index,
            song_name: songNames[data.index] || `Unknown Song ${data.index}`,
            song_duration: data.total,
            current_time: data.time
          }
        });
      }
    });
  }

  preloadAudio = (url: string) => {
    var audio = new Audio();
    audio.oncanplaythrough = this.loadedAudio;
    audio.src = url;
  }

  loaded: number = 0;  loadedAudio = () => {
    this.loaded++;
    if (this.loaded == this.audioFiles.length) {
      this.setState({ audio: true });
      
      // Event GTM - wszystkie pliki audio załadowane
      TagManager.dataLayer({
        dataLayer: {
          event: 'audio_preloaded',
          event_category: 'media',
          event_label: 'all_audio_files_loaded',
          audio_files_count: this.audioFiles.length
        }
      });
    }
  }
  onSelectPresentation = (presentation: number) => {
    const songNames = ['V Symfonia - Beethoven', 'Rydwany Ognia - Vangelis', "Don't stop me now - Queen"];
    
    // Event GTM - wybór prezentacji przez pilota
    TagManager.dataLayer({
      dataLayer: {
        event: 'presentation_selected',
        event_category: 'user_interaction',
        event_label: songNames[presentation] || `Presentation ${presentation}`,
        presentation_index: presentation,
        presentation_name: songNames[presentation] || `Unknown Presentation ${presentation}`,
        user_type: 'pilot'
      }
    });

    this.pilot.play(presentation);
    this.setState({ play: true, song: { index: presentation, time: 0, total: this.state.playlist[presentation] } });
  }

  render() {
    if (!this.state.online) {
      return <Layout><DeviceOffline /></Layout>
    }    if (!this.state.welcome) {
      return <Layout><SplashScreen loading={!this.state.audio} onOk={() => {
        // Event GTM - ukończenie ekranu powitalnego
        TagManager.dataLayer({
          dataLayer: {
            event: 'welcome_screen_completed',
            event_category: 'user_interaction',
            event_label: 'splash_screen_dismissed'
          }
        });
        this.setState({ welcome: true });
      }} /></Layout>
    }

    if (!this.state.localization) {
      return <Layout><Localization localizationOk={() => this.onLocalizationOk()} /></Layout>
    }

    if (!this.state.pilot && !this.state.join) {
      return <Layout><PresentationInProgress onAcceptJoin={() => this.setState({ join: true })} /></Layout>
    }

    return <Layout><Presentation play={this.state.play} files={this.audioFiles} song={this.state.song} initialTime={this.state.initialTime} playlist={this.state.playlist} pilot={this.state.pilot} onSelectedPresentation={(presentation: any) => this.onSelectPresentation(presentation)} /></Layout>
  }
}

export default App;
